export type ModuleEnvironment = "dev" | "staging" | "production" | string;

const getModuleEnvironment = (environment?: ModuleEnvironment): ModuleEnvironment =>
    environment || process.env.VOICIFY_ENVIRONMENT;

export const getAIAnsweringModuleId = (environment?: ModuleEnvironment): string | null => {

    const moduleEnvironment = getModuleEnvironment(environment);
    if (moduleEnvironment == "dev" || moduleEnvironment == "staging") {
        return "1593985d-76f2-47c8-a3cd-2ac4609834eb";
    }
    else if (moduleEnvironment == "production") {
        return "15079da8-21fd-455c-8f49-96829bd1c558";
    }
    return null;

};

export const getFoodOrderingModuleId = (environment?: ModuleEnvironment): string => {

    const moduleEnvironment = getModuleEnvironment(environment);
    if (moduleEnvironment == "dev" || moduleEnvironment == "staging") {
        return "317a55ec-2015-4003-8bc6-9a0598f0f234";
    }
    else if (moduleEnvironment == "production") {
        return "8dd914fe-d6af-4fe4-9379-0cfc59be35ab";
    }
    return null;

};

export const getHealthcareSchedulingModuleId = (environment?: ModuleEnvironment): string => {
    const moduleEnvironment = getModuleEnvironment(environment);
    if (moduleEnvironment == "dev" || moduleEnvironment == "staging") {
        return "fd64785a-e49f-4d23-ac36-da162137ff75";
    }
    else if (moduleEnvironment == "production") {
        return "73c00abf-09d5-4640-8b81-1a0c391bef9c";
    }
    return null;

};
